import $ from 'jquery';

import Section from '../Section';
import KenBurns from '../global/KenBurns';
import Parallax from '../global/Parallax';

export default class MapSection extends Section {
  /**
   * @param {import('../ThemeBase').default} theme
   * @param {HTMLElement} element
   * @param {boolean} pageLoad
   */
  constructor(theme, element, pageLoad) {
    super(theme, element, pageLoad);
    this.mapsApi = null;

    this.mapElement = element.querySelector('.map-wrapper');

    this.apiKey = this.element.dataset.mapsApikey;
    this.address = this.element.dataset.mapsAddress;

    if(!this.apiKey || !this.address) return;

    theme.loadGoogleMapApi(this.apiKey).then(this.onLoad).catch(this.showError);
    document.body.addEventListener('google-maps-auth-failure', this.onAuthError);

    this.kenBurns = new KenBurns(theme, element);
    this.parallax = new Parallax(theme, element);
  }

  onAuthError = (e) => {
    this.showError(e.detail.reason);
  }

  showError = (message) => {
    const container = this.element.querySelector('.map-section__container');
    container.classList.add('hide');
    if (window.Shopify.designMode) {
      $('<div class="map-container-error"></div>').text(message).appendTo(container.parentElement.querySelector('.map-section__overlay'));
    }
    container.parentElement.querySelector('.homepage-map--fallback').classList.remove('hide');
  }

  /**
   * This is called when Maps API is loaded
   * @param {import('../window').GoogleMapsApi} maps
   */
  onLoad = (maps) => {
    this.mapsApi = maps;
    const config = {
      zoom: 14
    };

    let style = [];
    try {
      const mapThemeElem = this.element.querySelector('.map-theme');
      if(mapThemeElem) {
        style = JSON.parse(mapThemeElem.textContent);
      }
    } catch (e) {
      console.error('Unable to parse theme style:', e);
    }
    const container = /** @type {HTMLElement} */ (this.element.querySelector('.map-section__container'));
    if (!container) {
      return;
    }
    this.map = new maps.Map(container, {
      zoom: config.zoom,
      styles: style,
      disableDefaultUI: true,
      draggable: false,
      clickableIcons: false,
      scrollwheel: false,
      disableDoubleClickZoom: true,
      draggableCursor: 'default'
    });

    this.geocoder = new maps.Geocoder();

    this.geocoder.geocode({'address': this.address}, (results, status) => {
      if (status === 'OK') {
        this.map.setCenter(results[0].geometry.location);
        this.marker = new maps.Marker({
          map: this.map,
          position: results[0].geometry.location
        });
      } else {
        this.showError('Error looking up that address');
      }
    });
  }

  onWindowResize = () => {
    // Center map when screensize is changed
    if (this.map) {
      const currCenter = this.map.getCenter();
      this.mapsApi.event.trigger(this.map, 'resize');
      this.map.setCenter(currCenter);
    }
  }
}
